import { gql } from '@apollo/client';
import PRODUCT_FRAGMENT from './product';
import PRODUCT_CURRICULUM_FRAGMENT from './product-curriculum';

const ORGANIZATION_LICENSE_FIELDS = gql`
  fragment OrganizationLicenseFields on Organization {
    licenseUsage {
      siteLicensed
      assignedCount
      availableCount
      inUseCount
      expiringCount
      totalCount
      productId
      product {
        ...BaseProduct
      }
      productCurriculum {
        ...BaseProductCurriculum
      }
      overageStats {
        availableCount
        assignedCount
        totalCount
        expiringCount
        overageLimitCount
      }
    }
  }
  ${PRODUCT_FRAGMENT}
  ${PRODUCT_CURRICULUM_FRAGMENT}
`;

export default ORGANIZATION_LICENSE_FIELDS;
